import { SlidersHorizontal } from "@phosphor-icons/react";
import { Button } from "@replicate/ui";
import type { Prediction } from "../../types";
import { route } from "../../urls";
import { usePlaygroundContext } from "./context";

export function TweakPrediction({
  prediction,
}: {
  prediction: Prediction;
}) {
  // We assume that every deployable other than deployments has a playground on
  // it root page.
  const tweakUrl = prediction._extras.deployment
    ? `${prediction._extras.deployment._extras.url}/playground?prediction=${prediction.id}`
    : `${prediction._extras.ran_on.url}?prediction=${prediction.id}`;

  return (
    <Button
      startIcon={<SlidersHorizontal />}
      variant="outlined"
      render={
        // biome-ignore lint/a11y/useAnchorContent: Content is injected by the component.
        <a href={tweakUrl} />
      }
    >
      Tweak it
    </Button>
  );
}
